<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {formatDate, copyObjectProperties, sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import UserEditModal from "./UserEditModal.svelte";


    let users = null;
    let userId = 0;
    let editUserId = null;

    const pageHeaderControls = [
        {id: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ ΧΡΗΣΤΗ', class: 'hidden-xs'},
        {id: 'create', name: '', icon: 'plus-circle', class: 'hidden-xl hidden-lg hidden-md hidden-sm'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΧΡΗΣΤΗΣ', sortable: true, sort_way: 'ASC'},
        {key: 'username', title: 'ΟΝΟΜΑ ΧΡΗΣΤΗ', sortable: true, class: 'hidden-xs'},
        {key: 'last_login', title: 'ΕΙΣΟΔΟΣ', sortable: true, class: 'hidden-xs'},
        {key: '', title: ''},
    ];

    const load = () => {
        const onSuccess = result => {
            users = result;
        }

        const onFailure = err => {
        };

        R.handle(R.user.index, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const onSearchChange = () => {
        load();
    }

    const onColumnSort = ({detail}) => {
        users = sort(users, detail.key, detail.sort_way === 'DESC');
    }

    const onCreate = () => {
        editUserId = 0;
    }

    const onEdit = (user) => {
        userId = user.id;
        editUserId = user.id;
    }

    const closeEdit = (user) => {
        if (user) {
            let properties = ['id', 'name', 'username', 'role_id', 'last_login'];

            let item = users.find(x => x.id == user.id);
            if (item) {
                copyObjectProperties(user, item, properties);
                users = users;
            } else {
                users = [copyObjectProperties(user, properties), ...users];
            }
        }
        editUserId = null;
    }

    const onDelete = (user) => {
        Alert.delete("Διαγραφή χρήστη", `Πρόκειται να διαγράψετε τον χρήστη "${user.name}".\nΘέλετε να συνεχίσετε;`, () => deleteUser(user.id));
    }

    const deleteUser = id => {
        const onSuccess = result => {
            users = users.filter(x => x.id != result);
            Notifier.showMessage("Ο χρήστης διαγράφτηκε");
        }

        const onFailure = err => {
            if (err.code === 'not_allowed') {
                Alert.warning("Διαγραφή χρήστη", `Δεν επιτρέπεται να διαγράψετε αυτόν τον χρήστη!`);
            }
        };

        R.handle(R.user.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<PageHeader title="Χρήστες" controls={ pageHeaderControls } on:create={ onCreate } on:reload={ load }/>

{#if users}
    <div class="panel">
        <div class="panel-body">
            {#if users.length}
                <table class="table table-list table-list-border">
                    <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                    <tbody>
                    {#each users as item}
                        <tr class="row-hover" class:row-selected="{ userId === item.id }">
                            <td>
                                <span class="is-link" class:fw-semibold={item.role_id == 1} on:click="{ () => onEdit(item) }">
                                    { item.name }
                                </span>
                            </td>
                            <td class="text-gray hidden-xs">
                                { item.username }
                            </td>
                            <td class="text-gray date-column hidden-xs">
                                { formatDate(item.last_login, 'd-m-y') }
                            </td>
                            <td class="button-column pointer" title="διαγραφή χρήστη" on:click="{ () => onDelete(item) }">
                                <AppIcon icon="trash" size="16"/>
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>
{/if}
{#if editUserId != null}
    <UserEditModal userId="{ editUserId }" closeCallback="{ closeEdit }"/>
{/if}